import React from "react";
import PropTypes from "prop-types";

import ExportButton from "../ExportButton";
import NewMessage from "./NewMessage/NewMessage";
import MessageTemplates from "./MessageTemplates";

const Header = ({
  currentUserIsAdmin,
  templates,
  search,
  onChangeSearch,
  onAdded,
  onDelete,
  onUpdated
}) => (
  <div>
    <div className="row">
      <div className="col-md-3 col-xs-12">
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons md-18">search</i>
          </span>
          <input
            className="form-control"
            placeholder="Search"
            type="text"
            value={search}
            onChange={onChangeSearch}
          />
        </div>
      </div>
      <div className="col-md-6 col-xs-12 pull-right">
        <br className="visible-xs visible-sm" />
        <div className="pull-right">
          <NewMessage templates={templates} />
          &nbsp;&nbsp;
          {currentUserIsAdmin && (
            <span>
              <MessageTemplates
                templates={templates}
                onAdded={onAdded}
                onDelete={onDelete}
                onUpdated={onUpdated}
              />
              &nbsp;&nbsp;
            </span>
          )}
          <ExportButton
            url="/export/messaging"
            className="btn btn-grey btn-raised btn-long hidden-xs"
          />
        </div>
      </div>
    </div>
  </div>
);

Header.propTypes = {
  currentUserIsAdmin: PropTypes.bool,
  templates: PropTypes.array,
  search: PropTypes.string,
  onChangeSearch: PropTypes.func,
  onAdded: PropTypes.func,
  onDelete: PropTypes.func,
  onUpdated: PropTypes.func
};

export default Header;
